import React from 'react';
import { Text } from '@chakra-ui/react';

const DashboardHeader = () => {
  return (
    <Text
      fontSize="2xl"
      fontWeight="bold"
      color="black"
      textAlign="center"
      mb={8}
      px={4}
      wordBreak="break-word"
      overflowWrap="break-word"
    >
      What can i help you with?
    </Text>
  );
};

export default DashboardHeader; 